module.exports = __webpack_public_path__ + "static/media/ceit.a7fd0089.png";